import api from "../api/axios.config";

export const userService = {
    
  async getUserInfo() {
    try {
      const response = await api.get(`/auth/user-info`);
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  }
}